import service from '@/api/service/service';
import qs from "qs";

export function getABList(params = {}) {
  return service({
    url: '/api/enroll/personnel_enroll_list.json',
    method: 'get',
    params,
  })
}

// 信息回显
export function info_view(params = {}) {
  return service({
    url: "/api/enroll/registration_info_view.json",
    method: 'get',
    params: params,
  });
}

// 保存学员信息
export function saveInfo(data = {}) {
  return service({
    url: "/api/enroll/personnel_enroll_one.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 获取所有的足协列表
export function organList(params = {}) {
  return service({
    url: "/api/enroll/organ_list.json",
    method: 'get',
    params: params,
  });
}

// 高端培训班注册第一步
export function highRegister_1(data = {}) {
  return service({
    url: "/api/index/personnel_check.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 报名用户注册发送验证码
export function personnel_send_verification(data = {}) {
  return service({
    url: "/api/index/personnel_send_verification.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 资质上传发送验证码
export function send_mobile_verification(data = {}) {
  return service({
    url: "/api/index/send_mobile_verification.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

//资质上传提交
export function coach_qualification_submit(data = {}) {
  return service({
    url: "/api/index/coach_qualification_submit.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 新报名人员注册
export function enroll_personnel_register(data = {}) {
  return service({
    url: "/api/index/enroll_personnel_register.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 报名人员上传的报告
export function registration_report_view(data = {}) {
  return service({
    url: "/api/enroll/registration_report_view.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 查询报名人员的报名状态
export function personnel_admission_status(data = {}) {
  return service({
    url: "/api/enroll/personnel_admission_status.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 报名人员上传文件
export function personnel_enroll_two(data = {}) {
  return service({
    url: "/api/enroll/personnel_enroll_two.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 报名人员上传文件
export function binding_org(data = {}) {
  return service({
    url: "/api/organization/binding_org.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 高端注册人员注册第一步接口
export function coach_register_check(data = {}) {
  return service({
    url: "/api/index/coach_register_check.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 高端注册人员注册第二步接口
export function coach_register_ajax(data = {}) {
  return service({
    url: "/api/index/coach_register_ajax.json",
    method: 'post',
    data: qs.stringify(data),
  });
}
//资质上传的机构列表

export function filtrate_data(data = {}) {
  return service({
    url: "/api/index/filtrate_data.json",
    method: 'post',
    data: qs.stringify(data),
  });
}


// 报名用户是否需要完善信息

export function registration_status_check(params = {}) {
  return service({
    url: "/api/enroll/registration_status_check.json",
    method: 'get',
    params,
  });
}


// 机构管理员首页 调用  返回待审核报名人员数量
export function enroll_personnel_num(params = {}) {
  return service({
    url: "/api/enroll/enroll_personnel_num.json",
    method: 'get',
    params,
  });
}


// 报名用户的身份
export function personnel_identity_data(params = {}) {
  return service({
    url: "/api/enroll/personnel_identity_data.json",
    method: 'get',
    params,
  });
}

//职业级报名申请提交数据


export function HMT_user_apply(data = {}) {
  return service({
    url: "/api/index/HMT_user_apply.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 学员提交缺失资质时 提供给继续教育报名列表供选择 未开始、进行中
export function getEduEnroll(data = {}) {
  return service({
    url: "/api/index/personnel_enroll_list_edu.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 学员提交缺失资质后 编辑 是否用于本年度继续报名接口
export function editEnterEnrollStatus(data = {}) {
  return service({
    url: "/api/index/edit_enter_enroll_status.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 此申请是否用于本年度继续教育报名控制
export function qualification_JxPermission(params = {}) {
  return service({
    url: '/api/index/qualificationJxPermission.json',
    method: 'get',
    params,
  })
}